// Which tabs of a row fit its width (um/2026-10-31 дополнение: «Ещё» — только когда не влезают): all of them while they fit; otherwise
// the first ones that fit beside «Ещё», and a chosen tab that would be hidden takes the last visible place.

export interface TabsFit<K> { shown: K[]; hidden: K[] }

/** `widths` — of each tab in `keys` order; `more` — of the «Ещё» trigger; `gap` — between items; `avail` — the row's inner width. */
export function fitTabs<K>(keys: K[], widths: number[], more: number, gap: number, avail: number, chosen: K): TabsFit<K> {
  const w = (k: K) => widths[keys.indexOf(k)] ?? 0;
  const span = (ks: K[]) => ks.reduce((a, k) => a + w(k), 0) + gap * Math.max(ks.length - 1, 0);
  // A pixel of rounding is not a reason to fold the row.
  if (span(keys) <= avail + 1) return { shown: keys, hidden: [] };
  const room = avail - more - gap;
  const shown: K[] = [];
  for (const k of keys) { if (span([...shown, k]) > room) break; shown.push(k); }
  if (keys.includes(chosen) && !shown.includes(chosen)) {
    while (shown.length && span([...shown, chosen]) > room) shown.pop();
    shown.push(chosen);
  }
  return { shown, hidden: keys.filter((k) => !shown.includes(k)) };
}
